'use strict';

var novicell = novicell || {};
var dataLayer = dataLayer || null; /*Google Tag Manager*/

novicell.search =
    novicell.search ||
    (function() {
        var doNotSearchBeforeCharAmount = 2;
        var doNotSearchBeforeMilisecondsAmount = 300;
        var lastType = 0;
        var timeOuts = {};
        var searchUrl = '';

        var elemToTriggerOpenSearchID = 'trigger-search';
        var elemSearchInputID = 'm-searchFieldGlobal-input';
        var searchPath = '/system/ajax/searchoverlay-page';
        var searchPage = '';
        var hiddenSearchOverlayContentID = '#overlayContent--searchFieldGlobal';
        var searchOverlayClass = 'novi-overlay--search';
        var searchOverlayBackdropClass = 'novi-backdrop--search';
        var searchOverlayInputFieldClass = '.' + searchOverlayClass + ' .m-searchFieldGlobal__search-field';
        var overlaySearchResultContainerSelector = '.' + searchOverlayClass + ' #overlay-search-result-container';

        function init() {
            findSearchUrl();
            initSearchTrigger();
            initSearchAsYouType();
            initGoToSearchPage();
            showSearchResultTotalOnSearchPage();
        }
        function showSearchResultTotalOnSearchPage() {
            var productHeader = document.getElementById('o-searchResults__categoryHeader--products');
            var pageHeader = document.getElementById('o-searchResults__categoryHeader--pages');
            var countHolder = document.getElementById('o-searchResults__resultCountTotal');
            if (productHeader != null && pageHeader != null && countHolder != null) {
                var resultCountProducts = productHeader.getAttribute('data-search-result-count') * 1;
                var resultCountPages = pageHeader.getAttribute('data-search-result-count') * 1;
                var resultCountTotal = resultCountProducts + resultCountPages;
                var countText = countHolder.innerHTML;
                countText = countText.replace('##', resultCountTotal);
                countHolder.innerHTML = countText;
            }
        }
        function initGoToSearchPage() {
            var body = document.querySelector('body');

            if (body != null) {
                body.addEventListener('submit', function(e) {
                    //if search form
                    if (e.target.classList.contains('m-searchFieldGlobal__form')) {
                        e.preventDefault();
                        var query = e.target.querySelector('.m-searchFieldGlobal__search-field').value;
                        var searchPageUrl = encodeURI(searchPage + query);
                        location.href = searchPageUrl;
                    }
                });
            }
        }
        function findSearchUrl() {
            var searchField = document.getElementById(elemSearchInputID);
            if (searchField != null) {
                if (searchPath != null) {
                    searchUrl = searchPath + '?search=';
                }
            }

            var searchFieldOverlay = document.getElementById('overlayContent--searchFieldGlobal');
            if (searchFieldOverlay != null) {
                if (searchPath != null) {
                    searchPage = searchFieldOverlay.getAttribute('data-search-page-link');
                }
            }
        }
        function search(inputValue) {
            clearMyTimeout();
            var searchValue = encodeURIComponent(inputValue);
            showResults(searchValue);
        }
        function setShowAllResultsButtonLink(searchValue) {
            var btnsShowAll = document.querySelectorAll('.a-link.o-searchBox__moreLink');
            for (var i = 0; i < btnsShowAll.length; i++) {
                var basicSearcPageUrl = btnsShowAll[i].getAttribute('data-href');
                if (basicSearcPageUrl != null && basicSearcPageUrl != undefined) {
                    btnsShowAll[i].setAttribute('href', basicSearcPageUrl + searchValue);
                }
            }
        }
        function showResults(searchValue) {
            if (searchUrl != '') {
                var url = searchUrl + searchValue;
                get(url).then(
                    function(response) {
                        var overlayContent = document.querySelector(overlaySearchResultContainerSelector);
                        if (overlayContent != null) {
                            overlayContent.innerHTML = response;
                        }
                        setShowAllResultsButtonLink(searchValue);
                    },
                    function(error) {
                        console.error('novicell.search:', error);
                    }
                );
            }
        }
        function clearMyTimeout() {
            if (timeOuts.myTimeout != undefined) {
                clearTimeout(timeOuts.myTimeout);
                delete timeOuts.myTimeout;
            }
        }
        function searchFieldChanged(e) {
            var searchField = document.querySelector(searchOverlayInputFieldClass);
            if (searchField != null) {
                var inputValue = searchField.value.trim();
                if (window.innerWidth >= 768) {
                    if (inputValue.length >= doNotSearchBeforeCharAmount) {
                        if (lastType == 0) {
                            lastType = Date.now();
                        }
                        var rightNow = Date.now();
                        var milisecondsSinceLastType = rightNow - lastType;
                        if (milisecondsSinceLastType <= doNotSearchBeforeMilisecondsAmount) {
                            clearMyTimeout();
                        }
                        lastType = rightNow;
                        if (timeOuts.myTimeout == undefined) {
                            timeOuts.myTimeout = setTimeout(search, doNotSearchBeforeMilisecondsAmount, inputValue);
                        }
                    }
                } else {
                    removeSearchResultOverlay();
                }
            }
        }
        function removeSearchResultOverlay() {
            var searchResultOverlay = document.querySelector('.novi-overlay #overlay-search-result-container');
            if (searchResultOverlay != null) {
                while (searchResultOverlay.firstChild) {
                    searchResultOverlay.removeChild(searchResultOverlay.firstChild);
                }
            }
        }
        function initSearchAsYouType() {
            var body = document.querySelector('body');

            if (body != null) {
                body.addEventListener('keyup', searchFieldChanged, false);
                body.addEventListener('paste', searchFieldChanged, false);
            }
        }

        function closeSearch() {
            var searchElementIfOpen = document.querySelector('.searchFieldGlobal--open');
            if (searchElementIfOpen != null) {
                searchElementIfOpen.classList.remove('searchFieldGlobal--open');
            }
        }

        function initSearchTrigger() {
            var searchTrigger = document.getElementById(elemToTriggerOpenSearchID);
            if (searchTrigger != null) {
                searchTrigger.addEventListener('click', function(e) {
                    e.preventDefault();

                    novicell.overlay.create({
                        selector: hiddenSearchOverlayContentID,
                        class: searchOverlayClass,
                        backdropClass: searchOverlayBackdropClass,
                        onLoaded: function() {
                            var inputField = document.querySelector(searchOverlayInputFieldClass);

                            if (inputField != null) {
                                inputField.addEventListener('focus', function() {
                                    if (dataLayer != null) {
                                        dataLayer.push({ event: 'soeg' });
                                    }
                                });

                                inputField.focus();
                            }
                        }
                    });
                });
            }
        }
        function searchResultsOverlayIsOpen() {
            var searchElem = document.getElementById('searchFieldGlobal');
            if (searchElem != null) {
                searchElem.classList.add('searchFieldGlobal--results-open');
            }

            //scroll to top
            var windowScrollY = window.pageYOffset;
            novicell.helpers.animate(document.scrollingElement || document.documentElement, 'scrollTop', '', windowScrollY, 0, 200, true);

            var searchInput = document.getElementById(elemSearchInputID);
            if (searchInput != null) {
                var searchValue = encodeURIComponent(searchInput.value);
            }

            setTimeout(function() {
                setShowAllResultsButtonLink(searchValue);
            }, 750);
        }
        function searchResultsOverlayIsClosed() {
            var searchElem = document.getElementById('searchFieldGlobal');
            if (searchElem != null) {
                searchElem.classList.remove('searchFieldGlobal--results-open');
            }

            //make sure search box is closed
            closeSearch();
        }

        function get(url) {
            // Return a new promise.
            return new Promise(function(resolve, reject) {
                // Do the usual XHR stuff
                var req = new XMLHttpRequest();
                req.open('GET', url);
                req.onload = function() {
                    if (req.status >= 200 && req.status < 400) {
                        // Success!!
                        resolve(req.response);
                    } else {
                        // Error!!
                        reject(Error(req.statusText));
                    }
                };

                // Handle network errors
                req.onerror = function() {
                    reject(Error('Network Error'));
                };

                // Make the request
                req.send();
            });
        }

        return {
            init: init,
            searchResultsOverlayIsOpen: searchResultsOverlayIsOpen,
            searchResultsOverlayIsClosed: searchResultsOverlayIsClosed
        };
    })();

function searchResultsOverlayIsOpen() {
    novicell.search.searchResultsOverlayIsOpen();
}
function searchResultsOverlayIsClosed() {
    novicell.search.searchResultsOverlayIsClosed();
}
